module.exports = __webpack_public_path__ + "img/Dantam Makeover 25.42ebb9c9.jpg";